import {AuthProvider, localStorageStore, RaRecord} from 'react-admin';
import {IUserRole} from "../models/role-model";
import {getPermissionsFromRoles} from "@react-admin/ra-rbac";

const localStore = localStorageStore();
const fakeValidToken =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiRmFrZSBUb2tlbiIsImlhdCI6MTUxNjIzOTAyMn0.lmyrT_2vTbnuF5XZ1pPCRztbXDLn-mfqWZTAZBFp4p8';

export const devAuthProvider: AuthProvider = {
    login: async (params: { user: RaRecord, usersRoles: any, allRoles: any }) => {
        const {user, usersRoles, allRoles} = params;

        const getUserRoles = () => {
            return (usersRoles as IUserRole[])
                .filter((u) => u.Users_Roles.some((r) => r.user_id === user.id))
                .map((u) => u.name);
        }

        const getCrmRoles = () => {
            return allRoles.find((r: any) => r.name === 'crm').config;
        }

        const getPermissions = () => {
            return getPermissionsFromRoles({
                roleDefinitions: getCrmRoles(),
                userRoles: getUserRoles(),
            });
        }

        const setAuthData = () => {
            localStore.setItem('userRoles', getUserRoles());
            localStore.setItem('userPermissions', getPermissions());
            localStore.setItem('userEmail', user.email);
            localStore.setItem('userId', user.id);
            localStore.setItem('fullName', user.name);
            localStore.setItem('avatar', user.AvatarPicture);
            localStorage.setItem('loggedIn', 'true');
            localStorage.setItem('token', fakeValidToken);
        }

        try {
            if (!user || !usersRoles || !allRoles) {
                return Promise.reject();
            }

            setAuthData();

            return Promise.resolve({
                id: user.id,
                permissions: getPermissions(),
                email: user.email,
            });
        } catch (error: any) {
            return Promise.reject('An error occurred');
        }
    },

    logout: () => {
        localStore.reset();
        localStorage.removeItem('loggedIn');

        return Promise.resolve();
    },

    checkAuth: () => {
        const loggedIn = localStorage.getItem('loggedIn');

        if (!loggedIn) {
            return Promise.reject();
        }

        return Promise.resolve();
    },

    checkError: (error: any) => {
        const status = error.status;

        if (status === 401 || status === 403) {
            localStorage.removeItem('loggedIn');
            return Promise.reject();
        }

        return Promise.resolve();
    },

    getIdentity: () => {
        const raUser = {
            id: localStore.getItem('userId'),
            fullName: localStore.getItem('fullName'),
            avatar: localStore.getItem('avatar'),
        }

        return Promise.resolve(raUser);
    },

    getPermissions: () => {
        const permissions = localStore.getItem('userPermissions');

        if (!permissions) return Promise.reject('No permissions');

        return Promise.resolve(permissions);
    },
};
